import { Company } from './companies';
import { FeedbackPriority } from './feedback-priority';
import { GetFilterDropdown, Products } from './feedback-product';
import { FeedbackStatus } from './feedback-status';
import { FeedbackType } from './feedback-type';
import { FilterMetadata, SubFilterMetadata } from './filterConfigurationTypes';

export const FilterConfig: FilterMetadata = {
  AssetTypeId: {
    key: 'AssetTypeId',
    type: 'select',
    name: 'Asset Type',
    options: [
      { key: 'screwPackage', label: 'Screw Package' },
      { key: 'bareScrew', label: 'Bare Screw' },
      { key: 'piston', label: 'Bare Piston' },
      { key: 'omni', label: 'Omni' },
    ],
  },
  AnnunciationStatus: {
    key: 'annun_status',
    type: 'multiSelect',
    name: 'Annunciation Status',
    isClientSide: true,
    clientFilterFunction: () => {},
    options: [
      { key: 0, label: 'Normal' },
      { key: 1, label: 'Warning' },
      { key: 2, label: 'Shutdown' },
    ],
  },
  FeedbackType: {
    key: 'TypeId',
    type: 'multiSelect',
    name: 'Type',
    options: [
      { key: FeedbackType.Feedback, label: 'Feedback' },
      { key: FeedbackType.FeatureRequest, label: 'Feature Request' },
      { key: FeedbackType.ProblemBug, label: 'Problem / Bug' },
    ],
  },
  FeedbackPriority: {
    key: 'PriorityId',
    type: 'multiSelect',
    name: 'Priority',
    options: [
      { key: FeedbackPriority.Na, label: 'N/A' },
      { key: FeedbackPriority.Low, label: 'Low' },
      { key: FeedbackPriority.Medium, label: 'Medium' },
      { key: FeedbackPriority.High, label: 'High' },
      { key: FeedbackPriority.Urgent, label: 'Urgent' },
    ],
  },
  FeedbackStatus: {
    key: 'StatusId',
    type: 'multiSelect',
    name: 'Status',
    options: [
      { key: FeedbackStatus.New, label: 'New' },
      { key: FeedbackStatus.InReview, label: 'In Review' },
      { key: FeedbackStatus.Approved, label: 'Approved' },
      { key: FeedbackStatus.InDevelopment, label: 'In Development' },
      { key: FeedbackStatus.ReadyForTest, label: 'Ready For Test' },
      { key: FeedbackStatus.Done, label: 'Done' },
      { key: FeedbackStatus.Rejected, label: 'Rejected' },
      { key: FeedbackStatus.Deleted, label: 'Deleted' },
    ],
  },
  Company: {
    key: 'CompanyIds',
    type: 'multiSelect',
    name: 'Company',
    options: [
      { key: Company.None, label: 'None' },
      { key: Company.York, label: 'GEA York' },
      { key: Company.Berlin, label: 'GEA Berlin' },
      { key: Company.DenBosch, label: "GEA 's-Hertogenbosch" },
      { key: Company.EmeaSkids, label: 'GEA EMEA Skids' },
      {
        key: Company.EmeaSkidsServiceSales,
        label: 'GEA EMEA Skids (Service Sales)',
      },
      {
        key: Company.DenBoschServiceSales,
        label: "GEA 's-Hertogenbosch (Service Sales)",
      },
    ],
  },
  InternalOnly: {
    key: 'InternalOnly',
    type: 'select',
    name: 'Internal Only',
    internalOnly: true,
    options: [
      { key: false, label: 'No' },
      { key: true, label: 'Yes' },
    ],
  },
  PmDiscussion: {
    key: 'PmDiscussion',
    type: 'select',
    name: 'PM Discussion',
    internalOnly: true,
    options: [
      { key: false, label: 'No' },
      { key: true, label: 'Yes' },
    ],
  },
  Manufacturer: {
    key: 'Manufacturer',
    type: 'multiSelect',
    name: 'Manufacturer',
    options: [
      { key: 'grasso', label: 'Grasso' },
      { key: 'vilter', label: 'Vilter' },
      { key: 'fes', label: 'FES' },
      { key: 'york', label: 'GEA York' },
    ],
  },
  Model: {
    key: 'Model',
    type: 'select',
    name: 'Model',
    options: [
      { key: 'xa', label: 'XA' },
      { key: 'sp1', label: 'SP1 Retrofit' },
      { key: 'ks28mnb', label: 'KS28MNB' },
    ],
  },
  RepOffice: {
    key: 'SalesRep',
    type: 'autoMultiSelect',
    placeholder: 'Search Rep',
    name: 'Rep Name',
    prefetch: true,
  },
  SalesManager: {
    key: 'SalesManager',
    type: 'autoMultiSelect',
    placeholder: 'Search Sales Manager',
    name: 'Sales Manager',
    prefetch: true,
  },
  ProjectManager: {
    key: 'ProjectManager',
    type: 'autoMultiSelect',
    placeholder: 'Search Project Manager',
    name: 'Project Manager',
    prefetch: true,
  },
  Planner: {
    key: 'Planner',
    type: 'autoMultiSelect',
    placeholder: 'Search Planner',
    name: 'Planner',
    prefetch: true,
  },
  EndUser: {
    key: 'EndUser',
    type: 'autoMultiSelect',
    placeholder: 'Search End User',
    name: 'End User',
    prefetch: true,
  },
  Customer: {
    key: 'Customer',
    type: 'autoMultiSelect',
    placeholder: 'Search Customer',
    name: 'Customer',
    prefetch: true,
  },
  OSState: {
    key: 'State',
    type: 'autoMultiSelect',
    placeholder: 'Search State',
    name: 'State',
    prefetch: true,
  },
  CompressorModels: {
    key: 'ItemDescription',
    type: 'groupedMultiSelect',
    name: 'Compressor Model',
    placeholder: 'Search Compressors',
    groupedOptions: [
      {
        name: 'GMX Series',
        options: [
          { key: '55GMX', label: '55GMX' },
          { key: '60GMX', label: '60GMX' },
          { key: '75GMX', label: '75GMX' },
          { key: '85GMX', label: '85GMX' },
          { key: '110GMX', label: '110GMX' },
          { key: '125GMX', label: '125GMX' },
          { key: '160GMX', label: '160GMX' },
          { key: '195GMX', label: '195GMX' },
        ],
      },
      {
        name: 'GLX Series',
        options: [
          { key: '230GLX', label: '230GLX' },
          { key: '290GLX', label: '290GLX' },
          { key: '340GLX', label: '340LX' },
          { key: '400GLX', label: '400GLX' },
          { key: '475GLX', label: '475GLX' },
          { key: '565GLX', label: '565GLX' },
          { key: '675GLX', label: '675GLX' },
          { key: '800GLX', label: '800GLX' },
          { key: '1025GLX', label: '1025GLX' },
          { key: '1210GLX', label: '1210GLX' },
          { key: '1435GLX', label: '1435GLX' },
        ],
      },
      {
        name: 'GL Series',
        options: [
          { key: '180GL', label: '180GL' },
          { key: '230GL', label: '230GL' },
          { key: '290GL', label: '290GL' },
          { key: '340GL', label: '340GL' },
          { key: '475GL', label: '475GL' },
          { key: '565GL', label: '565GL' },
          { key: '675GL', label: '675GL' },
          { key: '800GL', label: '800GL' },
          { key: '1025GL', label: '1025GL' },
          { key: '1025GL-48V', label: '1025GL-48V' },
          { key: '1210GL-48V', label: '1210GL-48V' },
          { key: '1210GL', label: '1210GL' },
          { key: '1435GL', label: '1435GL' },
          { key: '1435GL-48V', label: '1435GL-48V' },
          { key: '1770GL', label: '1770GL' },
          { key: '2110GL', label: '2110GL' },
        ],
      },
    ],
  },
  TurnInDate: {
    key: 'TurnInDate',
    type: 'dateRange',
    placeholder: 'Enter date range',
    name: 'Turn-in Date',
    dateFormat: 'MM/DD/YYYY',
  },
  ShipDate: {
    key: 'CurrentShipDate',
    type: 'dateRange',
    placeholder: 'Enter date range',
    name: 'Ship Date',
    dateFormat: 'MM/DD/YYYY',
  },
  // ApplicationId-1 and ApplicationId-2 are part of the same filter
  // but needs to be rendered in AND condition together.
  ApplicationId: {
    key: 'ApplicationId-1',
    type: 'select',
    name: 'Application Name',
  },
  ProductId: {
    key: 'ApplicationId-2',
    type: 'multiSelect',
    name: 'Product',
    options: GetFilterDropdown(Products),
  },
  FeedbackUser: {
    key: 'UserName',
    type: 'select',
    name: 'Feedback UserName',
  },
  UserId: {
    key: 'UserId',
    type: 'select',
    name: 'Feedback UserId',
  },
  Country: {
    key: 'Country',
    type: 'select',
    name: 'Country',
  },
  Condition: {
    key: 'Condition',
    type: 'select',
    name: 'Condition',
  },
  State: {
    key: 'State',
    type: 'select',
    name: 'State',
  },

  DocumentCompany: {
    key: 'CompanyId',
    type: 'multiSelect',
    name: 'Company',
    options: [
      { key: Company.None, label: 'None' },
      { key: Company.York, label: 'GEA York' },
      { key: Company.Berlin, label: 'GEA Berlin' },
      { key: Company.DenBosch, label: "GEA 's-Hertogenbosch" },
      { key: Company.EmeaSkids, label: 'GEA EMEA Skids' },
    ],
  },

  DocumentLanguage: {
    key: 'Language',
    type: 'multiSelect',
    name: 'Language',
    options: [
      { key: 'Bulgarian', label: 'Bulgarian' },
      { key: 'Croatian', label: 'Croatian' },
      { key: 'Czech', label: 'Czech' },
      { key: 'Danish', label: 'Danish' },
      { key: 'Dutch', label: 'Dutch' },
      { key: 'English', label: 'English' },
      { key: 'English (GB)', label: 'English (GB)' },
      { key: 'English (US)', label: 'English (US)' },
      { key: 'Estonian', label: 'Estonian' },
      { key: 'Finnish', label: 'Finnish' },
      { key: 'French', label: 'French' },
      { key: 'German', label: 'German' },
      { key: 'Greek', label: 'Greek' },
      { key: 'Hungarian', label: 'Hungarian' },
      { key: 'Italian', label: 'Italian' },
      { key: 'Norwegian', label: 'Norwegian' },
      { key: 'Polish', label: 'Polish' },
      { key: 'Portuguese', label: 'Portuguese' },
      { key: 'Portuguese (BR)', label: 'Portuguese (BR)' },
      { key: 'Portuguese (PT)', label: 'Portuguese (PT)' },
      { key: 'Romanian', label: 'Romanian' },
      { key: 'Russian', label: 'Russian' },
      { key: 'Slovak', label: 'Slovak' },
      { key: 'Spanish (ES)', label: 'Spanish (ES)' },
      { key: 'Swedish', label: 'Swedish' },
      { key: 'Thai', label: 'Thai' },
      { key: 'Turkish', label: 'Turkish' },
    ],
  },

  DocumentProductFamnily: {
    key: 'ProductFamily',
    type: 'multiSelect',
    name: 'Product Family',
    options: [
      {
        key: 'Automation & Control Systems',
        label: 'Automation & Control Systems',
      },
      { key: 'Brewing Systems', label: 'Brewing Systems' },
      { key: 'Chillers & Heat Pumps', label: 'Chillers & Heat Pumps' },
      { key: 'Compressors', label: 'Compressors' },
      {
        key: 'Dryers & Particle Processing Plants',
        label: 'Dryers & Particle Processing Plants',
      },
      { key: 'Food Processing Systems', label: 'Food Processing Systems' },
      {
        key: 'Freezers Evaporators & Crystallizers',
        label: 'Freezers Evaporators & Crystallizers',
      },
      { key: 'Milking & Farming Systems', label: 'Milking & Farming Systems' },
      { key: 'Valves & Pumps', label: 'Valves & Pumps' },
    ],
  },

  DocumentType: {
    key: 'DocumentType',
    type: 'multiSelect',
    name: 'Document Type',
    options: [
      { key: 'Brochure', label: 'Brochure' },
      { key: 'CAD (2D)', label: 'CAD (2D)' },
      { key: 'CAD (3D)', label: 'CAD (3D)' },
      { key: 'Drawing', label: 'Drawing' },
      { key: 'Installation Instruction', label: 'Installation Instruction' },
      { key: 'Lubricants', label: 'Lubricants' },
      { key: 'Maintenance Instruction', label: 'Maintenance Instruction' },
      { key: 'Operating Instruction', label: 'Operating Instruction' },
      { key: 'Parts Manual', label: 'Parts Manual' },
      { key: 'Picture', label: 'Picture' },
      { key: 'Planning guide', label: 'Planning guide' },
      { key: 'Product Information', label: 'Product Information' },
      { key: 'Quick Reference Guide', label: 'Quick Reference Guide' },
      { key: 'Safety Instruction', label: 'Safety Instruction' },
      { key: 'Software', label: 'Software' },
      { key: 'Spare parts list', label: 'Spare parts list' },
      {
        key: 'Transportation instruction',
        label: 'Transportation instruction',
      },
    ],
  },

  DocumentFileType: {
    key: 'FileType',
    type: 'multiSelect',
    name: 'File Type',
    options: [
      { key: 'Document', label: 'Document' },
      { key: 'DWG', label: 'DWG' },
      { key: 'JPEG', label: 'jpeg' },
      { key: 'Layout', label: 'Layout' },
      { key: 'PDF', label: 'PDF' },
      { key: 'STEP', label: 'STEP' },
      { key: 'Video', label: 'Video' },
      { key: 'ZIP', label: 'ZIP' },
      { key: 'ipt', label: 'ipt' },
      { key: 'sat', label: 'sat' },
      { key: 'stp', label: 'stp' },
    ],
  },
};

export const SubFilterConfig: SubFilterMetadata = {
  assetTable: ['AssetTypeId', 'Manufacturer', 'Model'],
  feedbackAllTable: [
    'FeedbackType',
    'Company',
    'ProductId',
    'FeedbackPriority',
    'FeedbackStatus',
    'InternalOnly',
    'PmDiscussion',
  ],
  feedbackHRTConnectTable: [
    'FeedbackType',
    'Company',
    'FeedbackPriority',
    'FeedbackStatus',
    'InternalOnly',
    'PmDiscussion',
  ],
  feedbackMyTable: [
    'FeedbackType',
    'Company',
    'ProductId',
    'FeedbackPriority',
    'FeedbackStatus',
    'InternalOnly',
    'PmDiscussion',
  ],
  feedbackOmniTable: [
    'FeedbackType',
    'Company',
    'ProductId',
    'FeedbackPriority',
    'FeedbackStatus',
    'InternalOnly',
    'PmDiscussion',
  ],
  feedbackRTSelectTable: [
    'FeedbackType',
    'Company',
    'ProductId',
    'FeedbackPriority',
    'FeedbackStatus',
    'InternalOnly',
    'PmDiscussion',
  ],
  feedbackBluRedCareTable: [
    'FeedbackType',
    'Company',
    'ProductId',
    'FeedbackPriority',
    'FeedbackStatus',
    'InternalOnly',
    'PmDiscussion',
  ],
  feedbackBluRedSelectTable: [
    'FeedbackType',
    'Company',
    'ProductId',
    'FeedbackPriority',
    'FeedbackStatus',
    'InternalOnly',
    'PmDiscussion',
  ],
  dashboardIotAd: ['AnnunciationStatus'],
  orderStatus: [
    'RepOffice',
    'SalesManager',
    'ProjectManager',
    'Planner',
    'EndUser',
    'Customer',
    'OSState',
    'CompressorModels',
    'TurnInDate',
    'ShipDate',
  ],
  documentLibrary: [
    'DocumentCompany',
    'DocumentLanguage',
    'DocumentProductFamnily',
    'DocumentType',
    'DocumentFileType',
  ],
};
